<template>
  <DetalhamentoDuploClique
    :filtros_basicos="filtros_basicos"
    :histograma="item.histograma"
    :idsegmento="parseInt(item.idsegmento)"
    :idfornecedor="parseInt(item.idfornecedor)"
    :idproduto="item.idproduto ? String(item.idproduto) : undefined"
    :idgrupo="item.idproduto ? parseInt(item.idgrupo) : undefined"
    :produto_combinado="item.produto_combinado || item.descricao_linha === 'COMBINADOS'"
    :data="data"
  >
    <template #ativador="{callbackAtivarDialog}">
      <div :title="`R$ ${formatarValorComCasas(item[data], 2)}`" @dblclick="callbackAtivarDialog">
        <template v-if="!item[data] || Number(item[data]) === 0">-</template>
        <template v-else-if="Number(item[data]) > 1000">R$ {{ formatarValoresBi(item[data]) }}</template>
        <template v-else-if="Number(item[data]) < 1">R$ {{ formatarValorComCasas(item[data], 2) }}</template>
        <template v-else>R$ {{ formatarValor(Number(item[data]).toFixed(1)) }}</template>
      </div>
    </template>
  </DetalhamentoDuploClique>
</template>

<script>
import DetalhamentoDuploClique from "@/components/Diagnostico/SlowNoMoving/IndicadorEvolucao/DetalhamentoDuploClique/Index.vue";
import formatarValoresBi from "@/helpers/formatarValoresBi";
import {formatarValor, formatarValorComCasas} from "@/helpers";

export default {
  name: "Celula",
  components: {
    DetalhamentoDuploClique
  },
  props: {
    item: Object,
    data: String,
    filtros_basicos: Object,
  },
  methods: {
    formatarValoresBi,
    formatarValorComCasas,
    formatarValor,
  }
}
</script>

<style scoped>

</style>
